export const opposition_statuses = [
    'open',
    'suspended',
    'for_decision',
    'ended'
];
